import { disableScroll, enableScroll} from '../utils/scroll';
export default class Accordion {
  // default accordion selectors
  panelSelector = '.acc-item';
  activePanelSelector = '.acc-item.active';
  headSelector = '.acc-item__title-wrap';
  contentSelector = '.acc-item__content';
  wrapperSelector = '.section-acc__items';
  disclaimerPopup = document.querySelector('.legal-disclaimer');
  targetLinkDisclaimer = null;
  paddingSize = 0;

  // store active items to reduce number of DOM interactions
  activeItems = [];

  // timeoutId for resize debounce
  timeoutId = null;

  constructor({
                panelSelector,
                activePanelSelector,
                headSelector,
                contentSelector,
                wrapperSelector,
                paddingSize,
                disclaimerPopup,
                targetLinkDisclaimer,
              } = {}) {
    // redefine options
    if (panelSelector) this.panelSelector = panelSelector;
    if (activePanelSelector) this.panelSelector = activePanelSelector;
    if (headSelector) this.headSelector = headSelector;
    if (contentSelector) this.contentSelector = contentSelector;
    if (wrapperSelector) this.wrapperSelector = wrapperSelector;
    if (paddingSize) this.paddingSize = paddingSize;
    if (disclaimerPopup) this.disclaimerPopup = disclaimerPopup;
    this.targetLinkDisclaimer = targetLinkDisclaimer;
  }

  initListeners() {
    document.addEventListener('click', (e) => this.handleClick(e));
    document.addEventListener("keyup", (e) => {
      if(e.key === 'Escape' && this.disclaimerPopup?.classList.contains('show')) {
        this.disclaimerPopup.classList.remove('show')
        enableScroll()
      }
    });
  }

  handleClick(e) {
    const useDisclaimere = e.target.closest('.use-disclaimer');
    const copyLink = e.target.closest(".link-use-copy");
    if(this.disclaimerPopup.classList.contains('show')) {
      if(
        !e.target.closest('.legal-disclaimer__popup-wrapper') ||
        e.target.closest('.legal-disclaimer__close-btn') ||
        e.target.closest('.legal-disclaimer__agree')
      ) {
        this.disclaimerPopup.classList.remove('show')
        enableScroll()
        if(e.target.closest('.legal-disclaimer__agree')) {
          this.targetLinkDisclaimer.classList.add('is-agree')
        }
      }
    }

    if(useDisclaimere && e.target.closest('a.link-use-disclaimer') && !e.target.closest('a').classList.contains('is-agree')) {
      let targetLink = e.target.closest('a');
      let url = new URL(targetLink.href);
      let mediaId = url.searchParams.get("media_id");

      if (mediaId) {
        this.updateLegalDisclaimerLink(mediaId);
      }

      this.disclaimerPopup.querySelector('.legal-disclaimer__agree').setAttribute('href', targetLink.getAttribute('href'))
      e.preventDefault();
      this.targetLinkDisclaimer = e.target.closest('a');
      this.disclaimerPopup.classList.add('show')
      this.disclaimerPopup.scrollTop = 0;
      disableScroll()
    }

    const head = e.target.closest(this.headSelector);
    if (!head) return;
    const wrapper = e.target.closest(this.wrapperSelector)
    const panel = head.closest(this.panelSelector);
    const content = panel.querySelector(this.contentSelector);

    // check if clicked item already active
    const itemIndex = this.activeItems.findIndex((item) => item.panel === panel);

    if (itemIndex !== -1) {
      if (!e.target.closest(this.contentSelector)) {
        panel.classList.remove('active');
        // remove active item from storage
        this.activeItems.splice(itemIndex, 1);
      }
    } else {
      panel.classList.add('active');
      this.handleCloseOtherPanel(wrapper, panel);

      // add active items to storage
      this.activeItems.push({panel, wrapper, content});
    }

    if (copyLink) {
      e.preventDefault();
      this.copyLinkToClipboard(copyLink);
    }
  }

  updateLegalDisclaimerLink(mediaId) {
    this.disclaimerPopup.classList.add('show')
    if (mediaId) {
      fetch(`${themeVars.home}/wp-json/wp/v2/media/${mediaId}`)
        .then(response => response.json())
        .then(data => {
          let legalButton = document.querySelector(".legal-disclaimer__agree");
          if (legalButton) {
            legalButton.href = data.source_url;
          }
        })
        .catch(error => console.error(error));
    }
  }

  checkMediaIdOnLoad() {
    let pageUrl = new URL(window.location.href);
    let mediaId = pageUrl.searchParams.get("media_id");

    if (mediaId) {
      this.updateLegalDisclaimerLink(mediaId);
      this.disclaimerPopup.scrollTop = 0;
      disableScroll();
    }
  }

  handleCloseOtherPanel(elem, panel) {
    const elemAllPanels = [...elem.querySelectorAll(this.activePanelSelector)];
    this.activeItems = [];
    elemAllPanels.find((activePanel) => {
      if (activePanel !== panel) {
        activePanel.classList.remove('active');
        this.activeItems.splice(this.activeItems.findIndex((item) => item.panel === activePanel), 1);
      }
    });
  }

  handleResize() {
    // use stored active items
    this.activeItems?.forEach((activeItem) => {
      activeItem.content.style.height = 'auto';
      setTimeout(
        () => (activeItem.content.style.height = activeItem.content.scrollHeight + 'px'),
        500
      );
    });
  }

  copyLinkToClipboard(link) {
    navigator.clipboard.writeText(link).then(() => {
      link.classList.add("successful-copied");

      setTimeout(() => {
        link.classList.remove("successful-copied");
      }, 2000);
    })
      .catch(err => console.error(err));
  }

  handleActivePanels() {
    this.activeItems = [...document.querySelectorAll(this.activePanelSelector)];
  }

  init() {
    this.handleActivePanels();
    this.initListeners();
    this.checkMediaIdOnLoad();
  }
}
